import * as types from './actionTypes';

export const fetchBiometricDiscrepancy = (payload) => ({
  type: types.FETCH_BIOMETRIC_DISCREPANCY_REQUEST,
  payload,
});

export const fetchBiometricDevicePunch = (payload) => ({
  type: types.FETCH_BIOMETRIC_DEVICE_PUNCH_REQUEST,
  payload,
});

export const saveBiometricDevicePunch = (payload) => ({
  type: types.SAVE_BIOMETRIC_DEVICE_PUNCH_REQUEST,
  payload,
});

export const discrepancyShiftUpdate = (payload) => ({
  type: types.DISCREPANCY_SHIFT_UPDATE_REQUEST,
  payload,
});

export const discrepancyPunchUpdate = (payload) => ({
  type: types.DISCREPANCY_PUNCH_UPDATE_REQUEST,
  payload: payload,
});

export const fetchEmployeeShiftProcess = (payload) => ({
  type: types.FETCH_SHIFT_PROCESS_REQUEST,
  payload,
});

export const fetchEmployeeShiftProcessSuccess = (data) => ({
  type: types.FETCH_SHIFT_PROCESS_SUCCESS,
  payload: data,
});

export const fetchEmployeeShiftProcessFailure = (data) => ({
  type: types.FETCH_SHIFT_PROCESS_FAILURE,
  payload: data,
});

export const SaveEmployeeShiftProcess = (payload) => ({
  type: types.SAVE_SHIFT_PROCESS_REQUEST,
  payload,
});

export const saveEmployeeShiftProcessSuccess = (data) => ({
  type: types.SAVE_SHIFT_PROCESS_SUCCESS,
  payload: data,
});

export const saveEmployeeShiftProcessFailure = (data) => ({
  type: types.SAVE_SHIFT_PROCESS_FAILURE,
  payload: data,
});

export const fetchEmployeeShiftChange = (payload) => ({
  type: types.FETCH_SHIFT_CHANGE_REQUEST,
  payload,
});

export const fetchEmployeeShiftChangeSuccess = (data) => ({
  type: types.FETCH_SHIFT_CHANGE_SUCCESS,
  payload: data,
});

export const fetchEmployeeShiftChangeFailure = (data) => ({
  type: types.FETCH_SHIFT_CHANGE_FAILURE,
  payload: data,
});

export const fetchEmployeeShiftCode = (payload) => ({
  type: types.FETCH_SHIFT_EMPLOYEE_SHIFTCODE_REQUEST,
  payload,
});

export const fetchEmployeeShiftCodeSuccess = (data) => ({
  type: types.FETCH_SHIFT_EMPLOYEE_SHIFTCODE_SUCCESS,
  payload: data,
});

export const fetchEmployeeShiftCodeFailure = (data) => ({
  type: types.FETCH_SHIFT_EMPLOYEE_SHIFTCODE_FAILURE,
  payload: data,
});

export const saveEmployeeShift = (payload) => ({
  type: types.SAVE_SHIFT_CHANGE_REQUEST,
  payload,
});

export const saveEmployeeShiftSuccess = (data) => ({
  type: types.SAVE_SHIFT_CHANGE_SUCCESS,
  payload: data,
});

export const saveEmployeeShiftFailure = (data) => ({
  type: types.SAVE_SHIFT_CHANGE_FAILURE,
  payload: data,
});

export const fetchEmployeeShiftRemove = (payload) => ({
  type: types.FETCH_SHIFT_REMOVE_REQUEST,
  payload,
});

export const fetchEmployeeShiftRemoveSuccess = (data) => ({
  type: types.FETCH_SHIFT_REMOVE_SUCCESS,
  payload: data,
});

export const fetchEmployeeShiftRemoveFailure = (data) => ({
  type: types.FETCH_SHIFT_REMOVE_FAILURE,
  payload: data,
});

export const removeEmployeeShift = (payload) => ({
  type: types.REMOVE_SHIFT_REQUEST,
  payload,
});

export const removeEmployeeShiftSuccess = (data) => ({
  type: types.REMOVE_SHIFT_SUCCESS,
  payload: data,
});

export const removeEmployeeShiftFailure = (data) => ({
  type: types.REMOVE_SHIFT_FAILURE,
  payload: data,
});

// 🔹 Get Template
export const punchlistGetTemplate = (payload) => ({
  type: types.PUNCHLIST_GET_TEMPLATE_REQUEST,
  payload,
});

// 🔹 Import Punchlist
export const punchlistImport = (payload) => ({
  type: types.PUNCHLIST_IMPORT_REQUEST,
  payload,
});

// 🔹 Save Punchlist
export const punchlistSave = (payload) => ({
  type: types.PUNCHLIST_SAVE_REQUEST,
  payload,
});

export const fetchEmployeeMobilePunch = (data) => ({
  type: types.FETCH_EMPLOYEE_MOBILE_PUNCH_REQUEST,
  payload: data,
});

export const fetchEmployeeMobilePunchApprovalList = (data) => ({
  type: types.FETCH_EMPLOYEE_MOBILE_PUNCH_APPROVAL_REQUEST,
  payload: data,
});

export const fetchBreakingList = (data) => ({
  type: types.FETCH_EMPLOYEE_MOBILE_BREAKLISTS_REQUESTS,
  payload: data,
});

export const updateMobilePunchApprovalRequest = (data) => ({
  type: types.SAVE_GENERATED_MOBILE_APPROVAL_REQUEST,
  payload: data,
});

export const resetPunchEmployeeApprovalsList = () => ({
  type: "RESET_PUNCH_EMPLOYEE_APPROVAL_LIST",
  payload:[]
});

export const resetShiftChangeList = () => ({
  type: "RESET_SHIFT_CHANGE_LIST",
  payload:[]
});

export const deleteMobilePunch = (payload) => ({
  type: types.DELETE_MOBILE_PUNCH,
  payload,
});

export const resetEmployeeShiftProcess = () => ({
  type: types.RESET_SHIFT_PROCESS,
});